

export const competences = [
    {id: 0, label: ".Net"},
    {id: 1, label: "3dstudiomax"},
    {id: 2, label: "Adobe After Effects"},
    {id: 3, label: "Adobe Dreamweaver"},
    {id: 4, label: "Adobe Illustrator"},
    {id: 5, label: "Adobe Lightroom"},
    {id: 6, label: "Adobe Photoshop"},
    {id: 7, label: "Adobe Premiere"},
    {id: 8, label: "Amazon AWS"},
    {id: 9, label: "Angular"},
    {id: 10, label: "Archicad"},
    {id: 11, label: "Asana"},
    {id: 12, label: "Autocad"},
    {id: 13, label: "AutoCAD Mechanical"},
    {id: 14, label: "Autodesk Inventor"},
    {id: 15, label: "Autodesk Maya"},
    {id: 16, label: "Bash"},
    {id: 17, label: "BIM"},
    {id: 18, label: "Bloomberg"},
    {id: 19, label: "Bootstrap"},
    {id: 20, label: "C"},
    {id: 21, label: "C#"},
    {id: 22, label: "C++"},
    {id: 23, label: "Cad 2D"},
    {id: 24, label: "Cad 3D"},
    {id: 25, label: "Canva"},
    {id: 26, label: "Catia"},
    {id: 27, label: "CleverTap"},
    {id: 28, label: "Creativity"},
    {id: 29, label: "CSS"},
    {id: 30, label: "Cyber Security"},
    {id: 31, label: "D-MOD"},
    {id: 32, label: "Docker"},
    {id: 33, label: "ECDL"},
    {id: 34, label: "EERA"},
    {id: 35, label: "Emblem"},
    {id: 36, label: "Facebook for Business"},
    {id: 37, label: "Figma"},
    {id: 38, label: "Firebase"},
    {id: 39, label: "Flutter"},
    {id: 40, label: "Gimp"},
    {id: 41, label: "Git"},
    {id: 42, label: "Google Ads"},
    {id: 43, label: "Google AdSense"},
    {id: 44, label: "Google Analytics"},
    {id: 45, label: "Hadoop"},
    {id: 46, label: "Hootsuit"},
    {id: 47, label: "HTML"},
    {id: 48, label: "Market surveys"},
    {id: 49, label: "InDesign"},
    {id: 50, label: "InVision"},
    {id: 51, label: "Java"},
    {id: 52, label: "Javascript"},
    {id: 53, label: "JMP"},
    {id: 54, label: "jQuery"},
    {id: 55, label: "Kubernetes"},
    {id: 56, label: "LaTeX"},
    {id: 57, label: "Linkedin"},
    {id: 58, label: "Linux"},
    {id: 59, label: "Machine Learning"},
    {id: 60, label: "Mailchimp"},
    {id: 61, label: "MATLAB"},
    {id: 62, label: "Microsoft Azure"},
    {id: 63, label: "Microsoft Office"},
    {id: 64, label: "Minitab"},
    {id: 65, label: "Miro"},
    {id: 66, label: "Modo"},
    {id: 67, label: "MongoDB"},
    {id: 68, label: "mySQL"},
    {id: 69, label: "Node.js"},
    {id: 70, label: "Oracle"},
    {id: 71, label: "Work organization"},
    {id: 72, label: "PHP"},
    {id: 73, label: "PostgreSQL"},
    {id: 74, label: "PowerCivil"},
    {id: 75, label: "Python"},
    {id: 76, label: "R"},
    {id: 77, label: "React"},
    {id: 78, label: "Rhinoceros"},
    {id: 79, label: "Ruby on Rails"},
    {id: 80, label: "Salesforce"},
    {id: 81, label: "SAP"},
    {id: 82, label: "SAS"},
    {id: 83, label: "Sass"},
    {id: 84, label: "Scala"},
    {id: 85, label: "Scrum"},
    {id: 86, label: "SEM"},
    {id: 87, label: "SEO"},
    {id: 88, label: "Six Sigma"},
    {id: 89, label: "SketchUp"},
    {id: 90, label: "Social Media"},
    {id: 91, label: "Solid Edge"},
    {id: 92, label: "SolidWorks"},
    {id: 93, label: "Spss"},
    {id: 94, label: "SQL server"},
    {id: 95, label: "Stata"},
    {id: 96, label: "Substance"},
    {id: 97, label: "Android app development"},
    {id: 98, label: "iOS app development"},
    {id: 99, label: "Project development"},
    {id: 100, label: "Swift"},
    {id: 101, label: "Tableau"},
    {id: 102, label: "Team Work"},
    {id: 103, label: "TensorFlow"},
    {id: 104, label: "Traduzioni"},
    {id: 105, label: "Twitter Ads"},
    {id: 106, label: "Typescript"},
    {id: 107, label: "Unbounce"},
    {id: 108, label: "Unity"},
    {id: 109, label: "Unreal Engine"},
    {id: 110, label: "VBA"},
    {id: 111, label: "Vue"},
    {id: 112, label: "Webrepol"},
    {id: 113, label: "Wix"},
    {id: 114, label: "Wordpress"},
    {id: 115, label: "Workday"},
    {id: 116, label: "XML"},
    {id: 117, label: "ZBrush"},
    {id: 118, label: "Zucchetti"},
    {id: 119, label: "Pro Engineer"},
    {id: 120, label: "Creo"},
    {id: 121, label: "CRM"},
    {id: 122, label: "Word"},
    {id: 123, label: "Excel"},
    {id: 124, label: "PowerPoint"},
    {id: 125, label: "Outlook"},
    {id: 126, label: "OneNote"},
    {id: 127, label: "Teams"},
    {id: 128, label: "PowerBI"},
    {id: 129, label: "ISO language (for all machine tools)"},
    {id: 130, label: "Fanuc language"},
    {id: 131, label: "Heidenhain language"},
    {id: 132, label: "Selca language"},
    {id: 133, label: "Google Tag Manager"},
    {id: 134, label: "Google Search Console"},
    {id: 135, label: "SaaS"},
    {id: 136, label: "AI/ML"},
    {id: 137, label: "Cloud Native Application Architecture"},
    {id: 138, label: "Event Driven Architecture"},
    {id: 139, label: "Virtualization technologies"},
    {id: 140, label: "ERP"},
    {id: 141, label: "Security/Access Management"},
    {id: 142, label: "Mediated API"},
    {id: 143, label: "Service Mesh"},
    {id: 144, label: "Serverless Architecture"},
    {id: 145, label: "Microservices Architecture"},
    {id: 146, label: "Devops"},
    {id: 147, label: "Agile"},
    {id: 148, label: "Google Cloud"},
    {id: 149, label: "Microsoft Dynamics"},
    {id: 150, label: "Elevator driver licence"},
    {id: 151, label: "SQL"},
    {id: 152, label: "OLAP"},
    {id: 153, label: "Culique"},
    {id: 154, label: "QlikView"},
    {id: 155, label: "Knowage"},
    {id: 156, label: "Microsoft Reporting Services"},
    {id: 157, label: "Datawarehouse"},
    {id: 158, label: "Business Intellingece"},
    {id: 159, label: "Compliance"},
    {id: 160, label: "Fintech"},    
    {id: 161, label: "eLIMS"},
    {id: 162, label: "Empower 3"},
    {id: 163, label: "Omnic"},
    {id: 164, label: "GLP/GMP regulations"},
    {id: 165, label: "AS400"},
    {id: 166, label: "TeamSystem"}
];
